import catalogServer from "../../server/catalog";

const clientModule = {
  namespaced: true,
  state: () => ({
    refreshListeners: {
      fetchClient: {},
      fetchClientAlertNotes: {},
      fetchDocumentMenus: {},
      fetchEoc: {}
    },
    levelsOfCare: [],
    locations: [],
    genders: [],
    services: [],
    maritalStatuses: [],
    states: [],
    allergyTypes: [],
    allergySeverities: [],
    relationships: [],
    caseRoles: [],
    diagnosisCodeStatuses: [],
    nutritionCategories: [],
    nutritionMeals: [],
    allergens: [],
    reactions: [],
    reviewTypes: [],
    utilizationStatuses: [],
    insuranceCoverages: [],
    insuranceCompanies: [],
    medicationRoutes: [],
    measurements: [],
    taxonomyTypes: [],
    taxonomySpecialties: [],
    entityTypes: [],
    payerTypes: [],
    scheduleEventStatuses: [],
    races: [],
    ethnicities: [],
    languages: [],
    predefinedProtocols: [],
    placesOfService: [],
    sharePackages: [],
    dischargeReasons: [],
    clinicians: []
  }),
  mutations: {
    setLevelsOfCare(state, levelsOfCare) {
      state.levelsOfCare = levelsOfCare;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
    setGenders(state, genders) {
      state.genders = genders;
    },
    setServices(state, services) {
      state.services = services;
    },
    setMaritalStatuses(state, maritalStatuses) {
      state.maritalStatuses = maritalStatuses;
    },
    setStates(state, states) {
      state.states = states;
    },
    setAllergyTypes(state, allergyTypes) {
      state.allergyTypes = allergyTypes;
    },
    setAllergySeverities(state, allergySeverities) {
      state.allergySeverities = allergySeverities;
    },
    setRelationships(state, relationships) {
      state.relationships = relationships;
    },
    setCaseRoles(state, caseRoles) {
      state.caseRoles = caseRoles;
    },
    setDischargeReasons(state, dischargeReasons) {
      state.dischargeReasons = dischargeReasons;
    },
    setdiagnosisCodeStatuses(state, diagnosisCodeStatuses) {
      state.diagnosisCodeStatuses = diagnosisCodeStatuses;
    },
    setNutritionCategories(state, nutritionCategories) {
      state.nutritionCategories = nutritionCategories;
    },
    setNutritionMeals(state, nutritionMeals) {
      state.nutritionMeals = nutritionMeals;
    },
    setAllergens(state, allergens) {
      state.allergens = allergens;
    },
    setReactions(state, reactions) {
      state.reactions = reactions;
    },
    setReviewTypes(state, reviewTypes) {
      state.reviewTypes = reviewTypes;
    },
    setUtilizationStatuses(state, statuses) {
      state.utilizationStatuses = statuses;
    },
    setInsuranceCoverages(state, insuranceCoverages) {
      state.insuranceCoverages = insuranceCoverages;
    },
    setInsuranceCompanies(state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies;
    },
    setMedicationRoutes(state, medicationRoutes) {
      state.medicationRoutes = medicationRoutes;
    },
    setMeasurements(state, measurements) {
      state.measurements = measurements;
    },
    setTaxonomyTypes(state, taxonomyTypes) {
      state.taxonomyTypes = taxonomyTypes;
    },
    setTaxonomySpecialties(state, taxonomySpecialties) {
      state.taxonomySpecialties = taxonomySpecialties;
    },
    setEntityTypes(state, entityTypes) {
      state.entityTypes = entityTypes;
    },
    setPayerTypes(state, payerTypes) {
      state.payerTypes = payerTypes;
    },
    setScheduleEventStatuses(state, scheduleEventStatuses) {
      state.scheduleEventStatuses = scheduleEventStatuses;
    },
    setRaces(state, races) {
      state.races = races;
    },
    setEthnicities(state, ethnicities) {
      state.ethnicities = ethnicities;
    },
    setPredefinedProtocols(state, predefinedProtocols) {
      state.predefinedProtocols = predefinedProtocols;
    },
    setLanguages(state, languages) {
      state.languages = languages;
    },
    setPlacesOfService(state, placesOfService) {
      state.placesOfService = placesOfService;
    },
    setSharePackages(state, sharePackages) {
      state.sharePackages = sharePackages;
    },
    setClinicians(state, clinicians) {
      state.clinicians = clinicians;
    },
    dispatchListener(state, { listener, param }) {
      const newListener = { ...state.refreshListeners[listener] };
      newListener[param] = +new Date();
      state.refreshListeners[listener] = newListener;
    }
  },
  actions: {
    async fetchLevelsOfCare(context) {
      const levelsOfCare = await catalogServer.getLevelsOfCare();
      context.commit("setLevelsOfCare", levelsOfCare);
    },
    async fetchLocations(context) {
      const locations = await catalogServer.getLocations();
      context.commit("setLocations", locations);
    },
    async fetchGenders(context) {
      const genders = await catalogServer.getGenders();
      context.commit("setGenders", genders);
    },
    async fetchServices(context, existingPatient) {
      const services = await catalogServer.getAvailableServices(
        existingPatient
      );
      context.commit("setServices", services);
    },
    async fetchMaritalStatuses(context) {
      const maritalStatuses = await catalogServer.getMaritalStatuses();
      context.commit("setMaritalStatuses", maritalStatuses);
    },
    async fetchStates(context) {
      const states = await catalogServer.getStates();
      context.commit("setStates", states);
    },
    async fetchAllergyTypes(context) {
      const allergyTypes = await catalogServer.getAllergyTypes();
      context.commit("setAllergyTypes", allergyTypes);
    },
    async fetchAllergySeverities(context) {
      const allergySeverities = await catalogServer.getAllergySeverities();
      context.commit("setAllergySeverities", allergySeverities);
    },
    async fetchRelationships(context) {
      const relationships = await catalogServer.getRelationships();
      context.commit("setRelationships", relationships);
    },
    async fetchCaseRoles(context) {
      const caseRoles = await catalogServer.getCaseRoles();
      context.commit("setCaseRoles", caseRoles);
    },
    async fetchDischargeReasons(context) {
      const dischargeReasons = await catalogServer.getDischargeReasons();
      context.commit("setDischargeReasons", dischargeReasons);
    },
    async fetchDiagnosisCodeStatuses(context) {
      const diagnosisCodeStatuses = await catalogServer.getDiagnosisCodeStatuses();
      context.commit("setdiagnosisCodeStatuses", diagnosisCodeStatuses);
    },
    async fetchNutritionCategories(context) {
      const nutritionCategories = await catalogServer.getNutritionCategories();
      context.commit("setNutritionCategories", nutritionCategories);
    },
    async fetchNutritionMeals(context) {
      const nutritionMeals = await catalogServer.getNutritionMeals();
      context.commit("setNutritionMeals", nutritionMeals);
    },
    async fetchAllergens(context) {
      const allergens = await catalogServer.getAllergens();
      context.commit("setAllergens", allergens);
    },
    async fetchReactions(context) {
      const reactions = await catalogServer.getReactions();
      context.commit("setReactions", reactions);
    },
    async fetchReviewTypes(context) {
      const reviewTypes = await catalogServer.getReviewTypes();
      context.commit("setReviewTypes", reviewTypes);
    },
    async fetchUtilizationStatuses(context) {
      const statuses = await catalogServer.getUtilizationStatuses();
      context.commit("setUtilizationStatuses", statuses);
    },
    async fetchInsuranceCoverages(context) {
      const insuranceCoverages = await catalogServer.getInsuranceCoverages();
      context.commit("setInsuranceCoverages", insuranceCoverages);
    },
    async fetchInsuranceCompanies(context) {
      const insuranceCompanies = await catalogServer.getInsuranceCompanies();
      context.commit("setInsuranceCompanies", insuranceCompanies);
    },
    async fetchMedicationRoutes(context) {
      const medicationRoutes = await catalogServer.getMedicationRoutes();
      context.commit("setMedicationRoutes", medicationRoutes);
    },
    async fetchMeasurements(context) {
      const measurements = await catalogServer.getMeasurements();
      context.commit("setMeasurements", measurements);
    },
    async fetchClinicians(context, data) {
      const clinicians = await catalogServer.getClinicians(data);
      context.commit("setClinicians", clinicians);
    },
    async fetchPlacesOfService(context, locationId = null) {
      const placesOfService = await catalogServer.getPlacesOfService(locationId);
      context.commit("setPlacesOfService", placesOfService);
    }
  },
  getters: {
    listeners(state) {
      return state.refreshListeners;
    },
    levelsOfCareCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return state.levelsOfCare.filter(levelOfCare =>
          location.serviceIds.includes(levelOfCare.id)
        );
      }
      return [];
    },
    formsCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return rootState.formBuilder.list["main"].filter(form =>
          location.formIds.includes(form.id)
        );
      }
      return [];
    },
    formGroupsCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return rootState.formGroup.list.filter(formGoup =>
          location.formGroupIds.includes(formGoup.id)
        );
      }
      return [];
    },
    selectedLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      return location;
    }
  }
};

export default clientModule;
